import { MenuItemKey } from "../../Layout/Sidebar/MenuItemKey";
import OneLensListBuildings from "../../../Pages/OneLens/Buildings/List/ListBuildings";
import ViewVisitTrends from "../../../Pages/OneLens/Visits/ViewTrends/ViewVisitTrends";
import ViewSpaceOperationsOverview from "../../../Pages/OneLens/Spaces/ViewOperationsOverview/ViewSpaceOperationsOverview";
import ListCateringOrders from "../../../Pages/OneLens/CateringOrders/List/ListCateringOrders";
import ListDirectedCleaningSpaces from "../../../Pages/OneLens/Spaces/ListDirectedCleaning/ListDirectedCleaningSpaces";
import EditCateringItem from "../../../Pages/OneLens/CateringItems/Edit/EditCateringItem";
import EditNotification2 from "../../../Pages/OneLens/Notifications/Edit2/EditNotification2";
import ListUserNotifications from "../../../Pages/OneLens/UserNotifications/List/ListUserNotifications";
import ListMostRecentEnvironmentalDataByZone from "../../../Pages/OneLens/EnvironmentalData/ListMostRecentByZone/ListMostRecentEnvironmentalDataByZone";
import ListSensors from "../../../Pages/OneLens/Sensors/List/ListSensors";
import ViewEnvironmentalDataOverview from "../../../Pages/OneLens/EnvironmentalData/ViewOverview/ViewEnvironmentalDataOverview";
import ViewSpaceUtilisation2 from "../../../Pages/OneLens/Spaces/ViewUtilisation2/ViewSpaceUtilisation";
import ViewMostRecentEnvironmentalDataByZone from "../../../Pages/OneLens/EnvironmentalData/ViewMostRecentByZone/ViewMostRecentEnvironmentalDataByZone";
import ViewSensor from "../../../Pages/OneLens/Sensors/View/ViewSensor";
import ListFloorsAndViewFloorPlan from "../../../Pages/OneLens/Floors/ListAndViewPlan/ListFloorsAndViewFloorPlan";
import EditCateringOrder from "../../../Pages/Shared/CateringOrders/Edit/EditCateringOrder";
import ListCateringItems from "../../../Pages/OneLens/CateringItems/List/ListCateringItems";
import ViewCateringOrder from "../../../Pages/OneLens/CateringOrders/View/ViewCateringOrder";
import ListCateringOrderPolicies from "../../../Pages/OneLens/CateringOrderPolicies/List/ListCateringOrderPolicies";
import ListCostCodes from "../../../Pages/Shared/CostCodes/List/ListCostCodes";
import ListCateringMenus from "../../../Pages/OneLens/CateringMenus/List/ListCateringMenus";
import EditCateringSupplier from "../../../Pages/OneLens/CateringSuppliers/Edit/EditCateringSupplier";
import ListCateringSuppliers from "../../../Pages/OneLens/CateringSuppliers/List/ListCateringSuppliers";
import ViewBookingsSchedule from "../../../Pages/OneLens/Bookings/ViewSchedule/ViewBookingsSchedule";
import ViewVisitDashboard from "../../../Pages/OneLens/Visits/ViewDashboard/ViewVisitDashboard";
import EditCateringOrderPolicy from "../../../Pages/OneLens/CateringOrderPolicies/Edit/EditCateringOrderPolicy";
import EditCateringMenu from "../../../Pages/OneLens/CateringMenus/Edit/EditCateringMenu";
import ViewTrends from "../../../Pages/OneLens/Bookings/ViewTrends/ViewTrends";
import ListDietaryTerms from "../../../Pages/OneLens/CateringDietaryTerms/List/ListDietaryTerms";
import ListDeletedUsers from "../../../Pages/OneLens/Users/ListDeleted/ListDeletedUsers";
import OnelensHome from "../../../Pages/OneLens/Shared/Home/OnelensHome";
import OneLensEditNotification from "../../../Pages/OneLens/Notifications/Edit/EditNotification";
import OneLensListNotifications from "../../../Pages/OneLens/Notifications/List/ListNotifications";
import ListPantryTimeline from "../../../Pages/OneLens/CateringPantryTimeline/List/ListPantryTimeline";
import { ViewAnalytics } from "../../../Pages/OneLens/Visits/ViewAnalytics/ViewAnalytics";
import ViewBookingsManagedSchedule from "../../../Pages/OneLens/Bookings/ViewDashboard/ViewBookingsManagedSchedule";
import ListTasks from "../../../Pages/Shared/Tasks/List/ListTasks";
import ListVisits from "../../../Pages/Shared/Visits/List/ListVisits";
import EditVisit from "../../../Pages/Shared/Visits/Edit/EditVisit";
import EditTask from "../../../Pages/Shared/Tasks/Edit/EditTask";
import ListBookings from "../../../Pages/Shared/Bookings/List/ListBookings";
import SearchSpaces from "../../../Pages/Shared/Spaces/Search/SearchSpaces";
import EditBooking from "../../../Pages/Shared/Bookings/Edit/EditBooking";
import ViewBookingSeries from "../../../Pages/Shared/BookingSeries/View/ViewBookingSeries";
import ViewSpaceAnalyticsOverview from "../../../Pages/OneLens/Spaces/ViewAnalyticsOverview/ViewSpaceAnalyticsOverview";
import ViewSpaceUtilisation from "../../../Pages/OneLens/Spaces/ViewUtilisation/ViewSpaceUtilisation";
import { IRoute } from "./IbssRouter";
import ListSpaceLayouts from "../../../Pages/OneLens/Spaces/SpaceLayouts/ListSpaceLayouts";
import { rights } from "../../../Common/RightsManager";
import EditEvents from "../../../Pages/OneLens/Events/Edit/EditEvents";
import ListEvents from "../../../Pages/OneLens/Events/List/ListEvents";
import ListCateringTemplates from "../../../Pages/OneLens/CateringTemplates/List/ListCateringTemplate";
import EditCateringTemplate from "../../../Pages/OneLens/CateringTemplates/Edit/EditCateringTemplate";

export default class OneLensRoutes
{
    public routes: IRoute[] = [
        {
            isAuthorised: () => true,
            path: "/operational-services-buildings",
            component: OneLensListBuildings
        },
        {
            isAuthorised: () =>
                rights.ONELENS360.OperationalServices.Bookings.has() ||
                rights.ONELENS360.OperationalServices.Catering.has() ||
                rights.ONELENS360.OperationalServices.DirectedCleaning.has() ||
                rights.ONELENS360.OperationalServices.Notifications.has() ||
                rights.ONELENS360.OperationalServices.OccupancyMonitor.has() ||
                rights.ONELENS360.OperationalServices.Spaces.has() ||
                rights.ONELENS360.OperationalServices.Tasks.has() ||
                rights.ONELENS360.OperationalServices.Visitors.has()
            ,
            path: "/operational-services-buildings/:buildingid",
            component: OneLensListBuildings,
            menuItemId: MenuItemKey.OneLens
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Tasks.has(),
            path: "/one-lens/tasks",
            legacyPaths: [{ path: "/operational-services-tasks/:buildingid", parameterMap: { buildingid: 'building' } }],
            component: ListTasks,
            menuItemId: MenuItemKey.OneLens_Operations_Tasks
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Visitors.has(),
            path: '/one-lens/visits/:visit_Id/edit',
            legacyPaths: [{ path: "/operational-services-Visitors/:buildingid/visit/:visit_Id/:tab", parameterMap: { buildingid: 'building', tab: '' } }],
            component: EditVisit,
            menuItemId: MenuItemKey.OneLens_Operations_Visitors_List
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Visitors.has(),
            path: '/one-lens/visits',
            legacyPaths: [
                { path: "/operational-services-visitors/:buildingid/:tab/:filter", parameterMap: { "buildingid": "building" } },
                { path: "/operational-services-visitors/:buildingid/:tab", parameterMap: { "buildingid": "building" } },
                { path: "/operational-services-visitors/:buildingid", parameterMap: { "buildingid": "building" } }
            ],
            component: ListVisits,
            menuItemId: MenuItemKey.OneLens_Operations_Visitors_List
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Visitors.has(),
            path: "/operational-services-visitors-dashboard/:buildingid",
            component: ViewVisitDashboard,
            menuItemId: MenuItemKey.OneLens_Operations_Visitors_Dashboard
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Visitors.has(),
            path: "/operational-services-visitors-trends/:buildingid",
            component: ViewVisitTrends,
            menuItemId: MenuItemKey.OneLens_Operations_Visitors_Trends
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Tasks.has(),
            path: "/operational-services-tasks/:buildingid/task/:task_Id/:tab",
            component: EditTask,
            menuItemId: MenuItemKey.OneLens_Operations_Tasks
        },
        {
            isAuthorised: () => true,
            path: "/operational-services-home/",
            component: OnelensHome,
            menuItemId: MenuItemKey.OneLens_Home
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Bookings.has(),
            path: '/one-lens/bookings',
            legacyPaths: [
                { path: "/operational-services-bookings-list/:buildingid", parameterMap: { buildingid: 'building', status: 'booking-statuses' } },
                { path: "/operational-services-bookings/:buildingid/:tab", parameterMap: { buildingid: 'building', tab: '', status: 'booking-statuses' } },
                { path: "/operational-services-bookings/:buildingid/:tab/:filter", parameterMap: { buildingid: 'building', tab: '', filter: '', status: 'booking-statuses' } },
            ],
            component: ListBookings,
            menuItemId: MenuItemKey.OneLens_Operations_Bookings_List
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Bookings.has(),
            path: "/operational-services-bookings/:buildingid/bookings/:bookingid/:spaceId",
            component: EditBooking,
            menuItemId: MenuItemKey.OneLens_Operations_Bookings_List
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Bookings.has(),
            path: "/oneLens/:buildingId/booking-series/view/:seriesId",
            component: ViewBookingSeries,
            menuItemId: MenuItemKey.OneLens_Operations_Bookings_List
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Bookings.has(),
            path: "/buildings/:buildingId/bookings/trends",
            component: ViewTrends,
            menuItemId: MenuItemKey.OneLens_Operations_Bookings_Trends
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Bookings.has(),
            path: "/one-lens/bookings/schedule",
            legacyPaths: [{ path: "/buildings/:buildingid/bookings/schedule-view", parameterMap: { buildingid: "building" } }],
            component: ViewBookingsSchedule,
            menuItemId: MenuItemKey.OneLens_Operations_Bookings_ScheduleView
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Bookings.has(),
            path: "/one-lens/bookings/dashboard",
            legacyPaths: [{ path: "/buildings/:buildingid/bookings/dashboard", parameterMap: { buildingid: "building" } }],
            component: ViewBookingsManagedSchedule,
            menuItemId: MenuItemKey.OneLens_Operations_Bookings_Dashboard
        },
        {
            isAuthorised: () => true,
            path: "/operational-services-home/",
            component: OnelensHome,
            menuItemId: MenuItemKey.OneLens_Home
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: '/one-lens/catering-orders',
            legacyPaths: [
                { path: '/catering-orders/:buildingid', parameterMap: { buildingid: 'building' } },
                { path: '/operational-services-catering/:buildingid', parameterMap: { buildingid: 'building' } },
            ],
            component: ListCateringOrders,
            menuItemId: MenuItemKey.OneLens_Operations_Catering_CateringOrders
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/oneLens/:buildingId/catering/pantry-timeline",
            component: ListPantryTimeline,
            menuItemId: MenuItemKey.OneLens_Operations_Catering_PantryTimeline
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/one-lens/catering-items",
            legacyPaths: [{ path: '/catering-items/:buildingid', parameterMap: {'buildingid': 'building'}}],            
            component: ListCateringItems,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_CateringItems
        },
        {
            isAuthorised: () => rights.DATAMODEL.CateringTemplates.Read.has() && rights.ONELENS360.OperationalServices.CateringTemplates.has(),
            path: "/one-lens/catering-templates",
            component: ListCateringTemplates,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_Template
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/buildings/:buildingid/catering-order-policies",
            component: ListCateringOrderPolicies,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_OrderPolicy
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/buildings/:buildingid/catering-order-policies/new",
            component: EditCateringOrderPolicy,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_OrderPolicy
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/buildings/:buildingid/catering-order-policies/:policyId/edit",
            component: EditCateringOrderPolicy,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_OrderPolicy
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/operational-services-catering/:buildingid/catering/:spacecateringId",
            component: EditCateringItem,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_CateringItems
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/operational-services-catering/:buildingid/catering/:spacecateringId/view",
            component: ViewCateringOrder,
            menuItemId: MenuItemKey.OneLens_Operations_Catering_CateringOrders
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/one-lens/catering-menus",
            legacyPaths: [{ path: '/catering-menus/:buildingid', parameterMap: { 'buildingid': 'building' } }],
            component: ListCateringMenus,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_CateringMenus
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/buildings/:buildingId/catering-menus/new",
            component: EditCateringMenu,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_CateringMenus
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/buildings/:buildingId/catering-menus/:cateringMenuId/edit",
            component: EditCateringMenu,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_CateringMenus
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/one-lens/catering-dietary-terms",
            legacyPaths: [{ path: '/catering-dietary-terms/:buildingid', parameterMap: { 'buildingid': 'building' } }],
            component: ListDietaryTerms,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_DietaryTerms
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/buildings/:buildingId/catering-suppliers",
            component: ListCateringSuppliers,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_Suppliers
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/buildings/:buildingId/catering-suppliers/new",
            component: EditCateringSupplier,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_Suppliers
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/buildings/:buildingId/catering-suppliers/:supplierId/edit",
            component: EditCateringSupplier,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_Suppliers
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/operational-services-catering-suppliers/create/:buildingId",
            component: EditCateringSupplier,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_Suppliers
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/operational-services-catering-suppliers/edit/:buildingId/:supplierId",
            component: EditCateringSupplier,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_Suppliers
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.DirectedCleaning.has(),
            path: "/operational-services-directed-cleaning/:buildingid",
            component: ListDirectedCleaningSpaces,
            menuItemId: MenuItemKey.OneLens_Operations_DirectedCleaning
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.OrphanedBookings.has(),
            path: "/users/deleted",
            component: ListDeletedUsers,
            menuItemId: MenuItemKey.OneLens_Operations_DeletedUsers
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Notifications.has(),
            path: "/one-lens/notifications",
            legacyPaths: [{ path: '/operational-services-notifications/:buildingid', parameterMap: { 'buildingid': 'building' } }],
            component: ListUserNotifications,
            menuItemId: MenuItemKey.OneLens_Operations_Notifications
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Notifications.has(),
            path: "/one-lens/events",
            legacyPaths: [{ path: '/operational-services-events/:buildingid', parameterMap: { 'buildingid': 'building' } }],
            component: ListEvents,
            menuItemId: MenuItemKey.Onelens_Operations_Events_List
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Notifications.has(),
            path: "/operational-services-notifications/:buildingid/notifications/:notificationId",
            component: EditNotification2,
            menuItemId: MenuItemKey.OneLens_Operations_Notifications
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Notifications.has(),
            path: "/oneLens/:buildingid/announcements/create",
            component: OneLensEditNotification,
            menuItemId: MenuItemKey.OneLens_Operations_Announcements
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Notifications.has(),
            path: "/oneLens/:buildingid/announcements/edit/:notificationid",
            component: OneLensEditNotification,
            menuItemId: MenuItemKey.OneLens_Operations_Announcements
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Announcements.has(),
            path: "/one-lens/announcements",
            legacyPaths: [{ path: '/oneLens/:buildingid/announcements/list', parameterMap: { 'buildingid': 'building' } }],
            component: OneLensListNotifications,
            menuItemId: MenuItemKey.OneLens_Operations_Announcements
        },
        {
            isAuthorised: () => rights.ONELENS360.SustainabilityAnalytics.Zones.has(),
            path: "/sustainability-analytics-zones/:buildingid",
            component: ListMostRecentEnvironmentalDataByZone,
            menuItemId: MenuItemKey.OneLens_Analytics_Sustainability_Zones
        },
        {
            isAuthorised: () => rights.ONELENS360.SustainabilityAnalytics.Zones.has(),
            path: "/sustainability-analytics-zones/:buildingid/:zoneId",
            component: ViewMostRecentEnvironmentalDataByZone,
            menuItemId: MenuItemKey.OneLens_Analytics_Sustainability_Zones
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.CostCodes.has(),
            path: "/one-lens/cost-codes",
            legacyPaths: [{path: "/operational-cost-codes/:buildingid" , parameterMap: {buildingid: "building"}}],
            component: ListCostCodes,
            menuItemId: MenuItemKey.OneLens_Operations_CostCodes
        },
        {
            isAuthorised: () => rights.ONELENS360.SustainabilityAnalytics.Sensors.has(),
            path: "/sustainability-analytics-sensors/:buildingid",
            component: ListSensors,
            menuItemId: MenuItemKey.OneLens_Analytics_Sustainability_Sensors
        },
        {
            isAuthorised: () => rights.ONELENS360.SustainabilityAnalytics.Sensors.has(),
            path: "/sustainability-analytics-sensors/:buildingid/:sensorId",
            component: ViewSensor,
            menuItemId: MenuItemKey.OneLens_Analytics_Sustainability_Sensors
        },
        {
            isAuthorised: () => rights.ONELENS360.SustainabilityAnalytics.Overview.has(),
            path: "/sustainability-analytics-overview/:buildingid",
            component: ViewEnvironmentalDataOverview,
            menuItemId: MenuItemKey.OneLens_Analytics_Sustainability_Overview
        },
        {
            isAuthorised: () => rights.ONELENS360.SustainabilityAnalytics.Sensors.has(),
            path: "/sustainability-analytics-floors/:buildingid",
            component: ListFloorsAndViewFloorPlan,
            menuItemId: MenuItemKey.OneLens_Analytics_Sustainability_Floors
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/operational-services-catering/:buildingid/catering/:bookingid/:cateringOrderId/edit",
            component: EditCateringOrder,
            menuItemId: MenuItemKey.OneLens_Operations_Catering_CateringOrders
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Spaces.has(),
            path: "/operational-services-spaces/:buildingid",
            component: ViewSpaceOperationsOverview,
            menuItemId: MenuItemKey.OneLens_Operations_Spaces_Spaces
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Spaces.has(),
            path: "/operational-services-spaces/:buildingid/:tab",
            component: ViewSpaceOperationsOverview,
            menuItemId: MenuItemKey.OneLens_Operations_Spaces_Spaces
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Spaces.has(),
            path: "/operational-services-spaces/:buildingid/:tab/:filter",
            component: ViewSpaceOperationsOverview,
            menuItemId: MenuItemKey.OneLens_Operations_Spaces_Spaces
        },
        {
            isAuthorised: () => rights.DATAMODEL.Spaces.Read.has(),
            path: '/one-lens/spaces/search',
            legacyPaths: [{ path: '/operational-services/buildings/:buildingid/spaces/search', parameterMap: { 'buildingid': 'building' } }],
            component: SearchSpaces,
            menuItemId: MenuItemKey.OneLens_Operations_Bookings_List
        },
        {
            isAuthorised: () => rights.ONELENS360.SpaceAnalytics.Overview.has(),
            path: "/one-lens/spaces/analytics-overview",
            legacyPaths: [{ path: '/space-analytics-overview/:buildingid', parameterMap: { 'buildingid': 'building' } }],
            component: ViewSpaceAnalyticsOverview,
            menuItemId: MenuItemKey.OneLens_Analytics_Space_Overview
        },
        {
            isAuthorised: () => rights.ONELENS360.SpaceAnalytics.Analytics.has(),
            path: "/space-analytics-analytics",
            component: ViewSpaceUtilisation2,
            menuItemId: MenuItemKey.OneLens_Analytics_Space_Overview
        },
        {
            isAuthorised: () => rights.ONELENS360.SpaceAnalytics.Heatmaps.has(),
            path: "/one-lens/spaces/heatmaps",
            legacyPaths: [{ path: "/space-analytics-heatmaps/:buildingid", parameterMap: { buildingid: 'building' } }],
            component: ViewSpaceUtilisation,
            menuItemId: MenuItemKey.OneLens_Analytics_Space_Heatmaps
        },
        {
            isAuthorised: () => rights.ONELENS360.VisitorAnalytics.Overview.has(),
            path: "/onelens/visits/analytics",
            component: ViewAnalytics,
            menuItemId: MenuItemKey.OneLens_Analytics_Visitors
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.SpaceLayouts.has(),
            path: "/oneLens/:buildingId/space-layouts",
            component: ListSpaceLayouts,
            menuItemId: MenuItemKey.OneLens_Operations_Space_Layouts
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.Catering.has(),
            path: "/oneLens/event/:buildingid/:bookingid/:spaceid/:eventid",
            component: EditEvents,
            menuItemId: MenuItemKey.Onelens_Operations_Events_List
        },
        {
            isAuthorised: () =>rights.ONELENS360.OperationalServices.CateringTemplates.has() && rights.DATAMODEL.CateringTemplates.Read.has(),
            path: "/oneLens/create-catering-template/:buildingid/edit",
            component: EditCateringTemplate,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_Template
        },
        {
            isAuthorised: () => rights.ONELENS360.OperationalServices.CateringTemplates.has() && rights.DATAMODEL.CateringTemplates.Read.has(),
            path: "/oneLens/create-catering-template/:buildingid/:templateId/edit",
            component: EditCateringTemplate,
            menuItemId: MenuItemKey.Onelens_Operations_Catering_Template
        },
    ];
}